<template>
  <div>
    <h2 class="m-2">
      CIERRE COMERCIO
    </h2>
    <v-card class="pa-5">
      Contenido de Cierre Comercio
    </v-card>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.m-2 {
  margin: 1rem !important;
}
</style>
